// Subset of ReportSaleLineItemColumnName from ReportingService

export enum SaleLineItemReportTableGroupingColumnId {
  EventDateLocal = 'localEventDateTime',
  EventName = 'eventName',
  VenueName = 'venueName',
  CityName = 'cityName',
  StateProvince = 'stateProvince',
  CountryName = 'countryName',
  PerformerName = 'performerName',
  TopLevelCategoryName = 'topLevelCategoryName',
  ParentCategoryName = 'parentCategoryName',
  EventId = 'eventId',
  SaleId = 'saleId',
  SaleCostTypeName = 'saleCostTypeName',
  PaymentReferenceId = 'paymentReferenceId',
  ChargeReason = 'chargeReason',
  CreditReason = 'creditReason',
  CostMonth = 'costMonth',
  CostWeek = 'costWeek',
  CostDay = 'costDay',
  SellerAccountCurrencyCode = 'sellerAccountCurrencyCode',
}

export enum SaleLineItemReportTableValueColumnId {
  Cost = 'cost',
  Credit = 'credit',
  Charge = 'charge',
}

export const SALE_LINE_ITEM_REPORT_TABLE_FORMULA_COLUMNS: SaleLineItemReportTableValueColumnId[] =
  Object.values(SaleLineItemReportTableValueColumnId);
